import React from "react";
import TopNav from "../../../Components/TopNav";
import Navbar from "../../../Components/Navbar";
import DropdownNav from "../../../Components/DropdownNav";
import "./iqac.css";
import { Link } from "react-router-dom";
import Footer from "../../../Components/Footer";
import Example from "../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const iqac = () => {
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="init-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
        </div>
      </div>

      <div className="iqac-grid">
        <div className="flex flex-row items-center justify-center flex-wrap">
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Objectives</h2>
            <p>Objective of IQAC ...</p>
            <div>
              <Link to="/Objectives">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Quality Policy</h2>
            <p>Quality Policy of IQAC ...</p>
            <div>
              <Link to="/QualityPolicy">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Vision & Mission</h2>
            <p>Vision & Mission of IQAC ...</p>
            <div>
              <Link to="/VisionMission">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Self Study Report</h2>
            <p>Self Study Report of IQAC ...</p>
            <div>
              <Link to="/SelfStudyReport">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">IQAC Core Committe Members</h2>
            <p>IQAC Core Committe Members of IQAC ...</p>
            <div>
              <Link to="/IQACCoreCommitteMembers">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">DATA TEAM MEMBERS - IQAC</h2>
            <p>DATA TEAM MEMBERS - IQAC ...</p>
            <div>
              <Link to="/DATATEAMMEMBERS">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">AQAR REPORTS</h2>
            <p>AQAR REPORTS of IQAC ...</p>
            <div>
              <Link to="/AQAR REPORTS">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Department of Aide</h2>
            <p>Department of Aide of IQAC ...</p>
            <div>
              <Link to="/DepartmentofAide">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Quality Initiatives</h2>
            <p>Quality Initiatives of IQAC ...</p>
            <div>
              <Link to="/QualityInitiatives">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">IQAC Meetings</h2>
            <p>IQAC Meetings of IQAC ...</p>
            <div>
              <Link to="/IQACMeetings">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Peer Team Reports</h2>
            <p>Peer Team Reports of IQAC ...</p>
            <div>
              <Link to="/PeerTeamReports">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">NAAC Certificate</h2>
            <p>naac certificate of IQAC ...</p>
            <div>
              <Link to="/NAACCertificate">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Policies</h2>
            <p>policies of IQAC ...</p>
            <div>
              <Link to="/Policies">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">FEEDBACK - IQAC</h2>
            <p>FEEDBACK of IQAC ...</p>

            <div>
              <Link to="/FEEDBACK">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Role Of Honour</h2>
            <p>Role Of Honour of IQAC ...</p>
            <div>
              <Link to="/RoleOfHonour">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Best Practices - IQAC</h2>
            <p>Best Practices of IQAC ...</p>
            <div>
              <Link to="/BestPractices">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Distinctiveness - IQAC</h2>
            <p>Distinctiveness of IQAC ...</p>
            <div>
              <Link to="/Distinctiveness">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
          <div className="iqac-obj">
            <img
              src="https://sedge.in/New%20College/assest/logo.png"
              className="obj-logo"
            />
            <h2 className="text-lg font-bold">Students Satisfaction Survey - IQAC</h2>
            <p>Students Satisfaction Survey of IQAC ...</p>
            <div>
              <Link to="/StudentsSatisfactionSurvey">
                <button className="read-more">Read More ➔</button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default iqac;
